"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
exports.withButtonisation = withButtonisation;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("./styles/Button"));
var _excluded = ["className", "btnStyle", "btnSize", "link"],
  _excluded2 = ["className", "btnStyle", "btnSize", "link", "children"];
function getButtonClasses(_ref) {
  var className = _ref.className,
    btnStyle = _ref.btnStyle,
    btnSize = _ref.btnSize,
    link = _ref.link,
    icon = _ref.icon;
  var hasBtnStyle = !!btnStyle;
  var hasBtnSize = !!btnSize;
  var hasLink = !!link;
  var hasIcon = !!icon;
  var isStandard = !hasLink && !hasIcon;
  var isSmall = btnSize === 'small';
  return (0, _classnames["default"])('button', 'ripple', (0, _defineProperty2["default"])((0, _defineProperty2["default"])({
    'button--standard': isStandard,
    'button--link': hasLink,
    'button--icon': hasIcon
  }, "button--".concat(btnStyle), hasBtnStyle), "button--".concat(btnSize), hasBtnSize), _Button["default"].button, isStandard && _Button["default"].button_standard, hasLink && _Button["default"].button_link, hasIcon && _Button["default"].button_icon, isSmall && _Button["default"].button_small, className);
}
function withButtonisation(WrappedComponent) {
  return function (_ref2) {
    var className = _ref2.className,
      btnStyle = _ref2.btnStyle,
      btnSize = _ref2.btnSize,
      link = _ref2.link,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    var buttonClasses = getButtonClasses({
      className: className,
      btnStyle: btnStyle,
      btnSize: btnSize,
      link: link,
      icon: props.icon
    });
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, {
      className: buttonClasses
    }));
  };
}
var Button = exports.Button = /*#__PURE__*/_react["default"].forwardRef(function Button(_ref3, ref) {
  var className = _ref3.className,
    btnStyle = _ref3.btnStyle,
    btnSize = _ref3.btnSize,
    link = _ref3.link,
    children = _ref3.children,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
  var buttonClasses = getButtonClasses({
    className: className,
    btnStyle: btnStyle,
    btnSize: btnSize,
    link: link,
    icon: props.icon
  });
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    ref: ref,
    className: buttonClasses
  }), children);
});
Button.displayName = 'Button';
Button.defaultProps = {
  type: 'button'
};